// extracted by mini-css-extract-plugin
export default {"legalEntitiesWrapper":"LegalEntities_legalEntitiesWrapper__5osNZ"};